import type { ModalActionHandler } from './modalActionTypes';
import { unassignJob } from '../map/settlement';
import { getSettlement } from './settlementActionUtils';

export const fireGoldMinerAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.jobs.goldMiners <= 0) return false;
    if (!unassignJob(settlement, 'goldMiners')) return false;
    settlement.production.goldMine.progress.pop();
    return true;
};
